/**
 * Secure storage wrapper with:
 * - Try/catch for Safari private browsing and quota errors
 * - JSON parse safety
 * - sessionStorage for sensitive data (tokens), localStorage for preferences
 * - Error logging for debugging
 */

const SENSITIVE_KEYS = ['token', 'auth_token', 'refresh_token', 'user'];

function getStore(key) {
  // Sensitive data uses sessionStorage (cleared when browser closes)
  if (SENSITIVE_KEYS.some(sk => key.toLowerCase().includes(sk))) {
    return sessionStorage;
  }
  return localStorage;
}

export const secureStorage = {
  getItem(key) {
    try {
      return getStore(key).getItem(key);
    } catch (error) {
      console.error(`Storage read error for key "${key}":`, error.message);
      return null;
    }
  },

  setItem(key, value) {
    try {
      getStore(key).setItem(key, value);
      return true;
    } catch (error) {
      console.error(`Storage write error for key "${key}":`, error.message);
      return false;
    }
  },

  removeItem(key) {
    try {
      // Remove from both stores to be safe
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error(`Storage remove error for key "${key}":`, error.message);
      return false;
    }
  },

  getJSON(key, fallback = null) {
    try {
      const raw = getStore(key).getItem(key);
      if (raw === null) return fallback;
      return JSON.parse(raw);
    } catch (error) {
      console.error(`Storage JSON parse error for key "${key}":`, error.message);
      return fallback;
    }
  },

  setJSON(key, value) {
    try {
      getStore(key).setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.error(`Storage JSON write error for key "${key}":`, error.message);
      return false;
    }
  },

  clear() {
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch (error) {
      console.error('Storage clear error:', error.message);
    }
  }
};
